import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";

export default function HeaderMobile({ toggleOpenDrawer, currentWiidth }: any) {
  return (
    <div>
      <AppBar
        position="static"
        style={{
          display: currentWiidth > 980 ? "none" : "block",
          zIndex: 999,
          position: "fixed",
          backgroundColor: "rgb(0, 171, 179)",
        }}
      >
        <Toolbar>
          <IconButton
            onClick={() => {
              toggleOpenDrawer();
            }}
            size="large"
            edge="start"
            color="inherit"
            aria-label="menu"
            sx={{ mr: 2 }}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Systech Systems Inc
          </Typography>
        </Toolbar>
      </AppBar>
      {currentWiidth < 980 && (
        <div
          style={{
            height: 55,
          }}
        ></div>
      )}
    </div>
  );
}
